var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-button"},[(_vm.type==='rainbow')?_c('button',{staticClass:"button_one"},[_c('span',[_vm._t("default")],2)]):(_vm.type==='aurora')?_c('button',{staticClass:"button_two"},[_c('span',[_c('i'),_c('i'),_c('i'),_c('i'),_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }